/* eslint-disable object-shorthand */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from "react";
import { useNavigate, useNavigationType } from "react-router-dom";
import { observer } from "mobx-react";
import Handler from "./Modules/Handler";
import Table from "./Modules/Table";
import { useStore } from "../../store";
import { Wrap } from "./styles";
import Title from "../../components/Title";
import { useDidMountEffect } from "../../utils/custom";
import useKeyPress from "../../utils/custom/useKeyPress";
import { getItem } from "../../utils/nauth";
import SnackBar from "../../components/SnackBar/SnackBar";

const AIReview = () => {
  const {
    AIReviewStore: {
      setRows,
      resetDates,
      gridOption: { page, rowsPerPage, totalCount, rows },
      onPageChange,
      setGridOption,
    },
  } = useStore();
  const navigationType = useNavigationType();

  const [msgSB, setMsgSB] = useState("");
  const userRole = getItem("role");
  const isUserRole = () => {
    return userRole === "operator" || userRole === "admin";
  };

  useDidMountEffect(() => {
    setRows();
  }, [page, rowsPerPage]);

  useEffect(() => {
    // 디테일에서 백키로 돌아온 경우(POP) 싱글톤 store에 살아있는 rows/page/filter를
    // 그대로 유지한다. 재진입에서 resetDates+setRows를 다시 부르면 page/스크롤/정렬이
    // 초기화되어 사용자가 보던 위치를 잃기 때문이다.
    const isReturnFromDetail = navigationType === "POP" && rows.length > 0;
    if (isReturnFromDetail) return;

    // 신규 진입: 잔존 page가 범위를 벗어나면 DataGrid가 보정하며 setRows가
    // 중복 호출되므로, fetch 직전에 0으로 리셋해 둔다.
    setGridOption({ page: 0 });
    resetDates();
    setRows();
  }, []);

  const handleKeyDown = (event: KeyboardEvent) => {
    if (!isUserRole()) return;

    const element: HTMLElement = event.target as HTMLElement;
    if (element) {
      if (element.querySelector("div")?.id !== "openedDlg") {
        switch (element.tagName) {
          case "INPUT":
          case "LI":
          case "TEXTAREA":
          case "BUTTON":
            break;
          default:
            if (event.key === "ArrowRight") {
              const pageCount = Math.ceil(totalCount / rowsPerPage);
              if (pageCount > page + 1) {
                onPageChange(page + 1);
                event.preventDefault();
              }
            } else if (event.key === "ArrowLeft" && page >= 1) {
              onPageChange(page - 1);
              event.preventDefault();
            }
            break;
        }
      }
    }
  };

  useKeyPress(["ArrowRight", "ArrowLeft"], handleKeyDown);

  return (
    <Wrap>
      <Title label="AI Review" isDivider />
      <Handler />
      <Table />
      {msgSB !== "" && <SnackBar msg={msgSB} setMsg={setMsgSB} />}
    </Wrap>
  );
};

export default observer(AIReview);
